import React, { useContext, useState, useEffect, useRef } from 'react';
import { Table, Pagination } from 'rsuite';
import './report-table.scss';
import 'rsuite/dist/rsuite.min.css';
import { default as t } from '../../../utils/i18n';
import { Button, ModalWindow, Dropdown, AppTooltip } from '../../atoms';
import { DashService } from '../../../services';
import { UserContext, DashboardContext } from '../../../context';
import { createPostTrackUsagePayload, UsageIdentifierFlow } from '../../../utils/misc';
import { postTrackUsageAPI } from '../../../services/dash.service';

function ReportTable(props) {
  const { user } = useContext(UserContext);
  const { dashData } = useContext(DashboardContext);
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const username = user?.username;
  const authenticated = user?.authenticated;
  const [sortColumn, setSortColumn] = React.useState();
  const [sortType, setSortType] = React.useState();
  const [isLoading, setLoading] = React.useState(false);
  const [isNickName, setIsNickName] = React.useState(true);
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);
  const [checkedKeys, setCheckedKeys] = React.useState([]);
  let [data, setData] = React.useState();
  const [showShareModal, setshowShareModal] = useState(false);
  let editedReportName = React.createRef();
  const [usersList, setUsersList] = React.useState();
  const [selectedUser, setSelectedUser] = useState('');
  const [selectedReportShare, setSelectedReportShare] = useState();
  const [toaster, setToaster] = useState(false);
  const tableDataRef = useRef(null);

  const listData = props?.reportData;
  const updateDateFormat = val => {
    const d = new Date(val);
    const yyyy = d.getFullYear();
    let mm = d.getMonth() + 1; // Months start at 0!
    let dd = d.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    // const date = d.getHours() + ':' + (d.getMinutes() < 10 ? ("0" + d.getMinutes()) : d.getMinutes()) + " " + d.toLocaleDateString();
    return dd + '-' + mm + '-' + yyyy;
  };

  const countryFullName = (country, code) => {
    if (country && code && country.length && code.length) {
      const result = country.filter(o1 => code.some(o2 => o1.country_code === o2)).map(e => e.name);
      return result.sort().join(', ');
    }
  };

  listData.map(data => {
    data.dateRange = data?.criteria?.from_date
      ? updateDateFormat(data.criteria['from_date']) +
        ' - ' +
        updateDateFormat(data.criteria['to_date'])
      : '';
    data.advertiser = data?.criteria?.advertiser
      ? Array.isArray(data.criteria?.advertiser)
        ? data.criteria?.advertiser?.sort().join(', ')
        : data.criteria?.advertiser
      : null;
    data.country = data?.criteria?.country
      ? Array.isArray(data.criteria?.country)
        ? countryFullName(dashData?.countryList, data?.criteria?.country)
        : dashData.countryList
        ? dashData.countryList.find(e => e.country_code === data.criteria.country)
        : null
      : null;
    data.industry = data?.criteria?.industry
      ? Array.isArray(data.criteria?.industry)
        ? data.criteria?.industry?.sort().join(', ')
        : data?.criteria?.industry
      : null;
    let kpi = dashData?.kpiList?.find(kp => kp.sys_id === data.criteria?.kpi);
    data.kpi = kpi?.KPI_Metric ? kpi.KPI_Metric : null;
    data.checked = false;
    data.status = data?.progress?.status;
  });

  const handleChangeLimit = dataKey => {
    setPage(1);
    setLimit(dataKey);
  };
  const getData = () => {
    if (sortColumn && sortType) {
      if (sortColumn === 'createdModify') {
        listData.sort((a, b) => {
          let x = a['createdAt'];
          let y = b['createdAt'];
          if (sortType === 'asc') {
            return new Date(x) - new Date(y);
          } else {
            return new Date(y) - new Date(x);
          }
        });
      } else {
        listData.sort((a, b) => {
          let x = a[sortColumn];
          let y = b[sortColumn];
          if (typeof x === 'string') {
            x = x.charCodeAt();
          }
          if (typeof y === 'string') {
            y = y.charCodeAt();
          }
          if (sortType === 'asc') {
            return x - y;
          } else {
            return y - x;
          }
        });
      }
    }
    data = listData?.filter((v, i) => {
      const start = limit * (page - 1);
      const end = start + limit;
      return i >= start && i < end;
    });
    data.map(data => {
      let d = new Date(data.createdAt);
      data.createdModify = (
        ('0' + d.getDate()).slice(-2) +
        '-' +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        '-' +
        d.getFullYear() +
        ' ' +
        ('0' + d.getHours()).slice(-2) +
        ':' +
        ('0' + d.getMinutes()).slice(-2)
      ).toString();
    });
    ////console.log('data called', data);
    tableDataRef.current = data;
    return data;
  };

  useEffect(() => {
    if (tableDataRef?.current?.length) {
      const allAdvertiserIds = tableDataRef.current.flatMap(report => {
        return report?.criteria?.advertiser || [];
      });

      const localStorageUserObj = localStorage.getItem('user');
      const { usageAPIPayload, updatedLocalStorageUserValue } = createPostTrackUsagePayload(
        allAdvertiserIds,
        JSON.parse(localStorageUserObj),
        UsageIdentifierFlow.ADVERTISER
      );

      if (usageAPIPayload.ids.length) {
        postTrackUsageAPI(userAccessToken, username, {
          ...usageAPIPayload,
          userFlow: `business_insights`,
        });
      }
      localStorage.setItem('user', JSON.stringify(updatedLocalStorageUserValue));
    }
  }, [tableDataRef.current]);

  const handleSubmit = e => {
    e.preventDefault();
  };
  const handleSortColumn = (sortColumn, sortType) => {
    setTimeout(() => {
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
  };

  const handleRowClick = rowData => {
    // console.log(rowData,'on Row click data');
    if (rowData?.progress?.status === 'READY') {
      props.onRowClicked(rowData);
    }
  };

  const handleCheck = event => {
    //console.log(event,"event");
    // event.preventDefault();
    const keys = event.target.checked
      ? [...checkedKeys, event.target.value]
      : checkedKeys.filter(item => item !== event.target.value);
    setCheckedKeys(keys);
    event.stopPropagation();
  };

  const onNameEdit = (rowData, event) => {
    event.stopPropagation();
    listData.forEach(el => {
      el.action = '';
    });
    rowData.action = 'EDIT';
    setData(rowData);
  };

  const updateReport = async (event, rowData) => {
    event.stopPropagation();
    const data = {
      reportData: {
        reportName: editedReportName.current.value,
      },
      reportId: rowData.reportId,
    };
    try {
      setLoading(true);
      const reportListResponse = await DashService.updateReport(userAccessToken, username, data);
      props.onTableUpdate(true);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    } catch (error) {
      console.log(
        '\x1b[31m[Error]',
        '~File:report-table.jsx~',
        '==> Error updateReport ==>',
        null,
        '\x1b[0m'
      ); //debug
    }
  };

  const deleteReport = async (event, rowData, isMultiple = false) => {
    event.stopPropagation();
    let data = '';
    if (isMultiple) {
      data = {
        reportIds: checkedKeys,
      };
    } else {
      data = {
        reportIds: [rowData.reportId],
      };
    }
    try {
      const deleteReportResp = await DashService.deleteReport(userAccessToken, username, data);
      setToaster(true);
      setTimeout(() => {
        setToaster(false);
      }, 3000);
      if (isMultiple) {
        setCheckedKeys([]);
      }
      props.onTableUpdate(true);
    } catch (error) {
      console.log(
        '\x1b[31m[Error]',
        '~File:report-table.jsx~',
        '==> Error deleteReport ==>',
        null,
        '\x1b[0m'
      ); //debug
    }
  };

  async function getUsersList() {
    try {
      const usersListResponse = await DashService.getUsersList(userAccessToken, username);
      ////console.log('usersListResponse::', usersListResponse);
      const usersData = usersListResponse?.data?.data.map(user => ({
        value: user.email,
        label: user.name,
      }));
      setSelectedUser(usersData[0]);
      setUsersList(usersData);
    } catch (error) {
      console.log(
        '\x1b[31m[Error]',
        '~File:report-table.jsx~',
        '==> Error Get Users ==>',
        null,
        '\x1b[0m'
      ); //debug
      setUsersList([]);
    }
  }

  const onShareClick = (event, rowData) => {
    //console.log(event, 'rowData');
    event.stopPropagation();
    setSelectedReportShare(rowData);
    getUsersList();
    setshowShareModal(true);
  };
  const handleOnCloseShareModal = () => {
    setshowShareModal(false);
  };
  const toggleName = e => {
    e.stopPropagation();
    setIsNickName(!isNickName);
  };

  useEffect(() => {
    setPage(1);
  }, [props.reportData]);

  const TableCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Table.Cell
        {...props}
        title={rowData[dataKey]}
        className={rowData.status === 'READY' ? 'active' : null}
      >
        {rowData[dataKey]}
      </Table.Cell>
    );
  };
  // const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
  //   <Table.Cell {...props} style={{ padding: 0 }}>
  //     <div style={{ lineHeight: '46px' }}>
  //       <input
  //         type="checkbox"
  //         defaultChecked={checkedKeys.some(item => item === rowData[dataKey])}
  //         value={rowData[dataKey]}
  //         onClick={(e) => onChange(e)}
  //         className="input-check"
  //       />
  //     </div>
  //   </Table.Cell>
  // );
  const NameCell = ({ rowData, dataKey, isNickName, onChange, ...props }) => {
    const editing = rowData.action === 'EDIT';
    return (
      <div>
        <AppTooltip id="tool-tip" place="left" className="c-table-info-icon--tooltip" />
        <Table.Cell
          {...props}
          className={`report-name ${rowData.status === 'READY' ? 'active' : null}`}
          title={rowData[dataKey]}
        >
          {editing ? (
            <div className="edit-name">
              <input
                className="rs-input"
                ref={editedReportName}
                defaultValue={rowData[dataKey]}
                onClick={event => event.stopPropagation()}
              />
              {isLoading ? (
                <i className="eva eva-checkmark-outline " />
              ) : (
                <i
                  className="eva eva-save-outline"
                  data-tip={t('report.tooltip.save')}
                  data-for="tool-tip"
                  onClick={event => {
                    updateReport(event, rowData);
                  }}
                ></i>
              )}
            </div>
          ) : (
            <span>
              <div className="report-name-section">
                {isNickName ? rowData[dataKey] : rowData['reportId']}
              </div>
              <i
                onClick={event => {
                  onNameEdit(rowData, event);
                }}
                data-tip={t('report.tooltip.edit')}
                data-for="tool-tip"
                className="eva eva-edit-outline hover-icon"
              ></i>
            </span>
          )}
        </Table.Cell>
      </div>
    );
  };

  const getWidth = (value = 10) => {
    return window.innerWidth / value;
  };
  const StatusCell = ({ rowData, dataKey, onChange, ...props }) => {
    return (
      <Table.Cell {...props}>
        <div>
          <AppTooltip id="tool-tip1" place="left" className="c-table-info-icon--tooltip" />
          <div
            className={`options ${
              rowData[dataKey] === 'PROCESSING'
                ? 'in-progress'
                : rowData[dataKey] === 'READY'
                ? 'ready'
                : rowData[dataKey] === 'NEW'
                ? 'new'
                : rowData[dataKey] === 'ACCEPTED'
                ? 'veiw'
                : 'error'
            }`}
          >
            {rowData[dataKey] === 'PROCESSING' ? (
              <>
                <span>
                  <i className="eva eva-clock-outline"></i>
                  {t('create.report.show.answer.option.options3.type')}
                </span>
              </>
            ) : (
              ''
            )}
            {rowData[dataKey] === 'READY' ? (
              <>
                <span>
                  <i className="eva eva-bell-outline"></i>
                  {t('create.report.show.answer.option.options4.type')}
                </span>
              </>
            ) : (
              ''
            )}
            {rowData[dataKey] === 'NEW' ? (
              <>
                <span className="new">
                  <i className="eva eva-alert-circle-outline"></i>
                  {t('create.report.show.answer.option.options1.type')}
                </span>
              </>
            ) : (
              ''
            )}
            {rowData[dataKey] === 'ACCEPTED' ? (
              <>
                <span>
                  <i className="eva eva-checkmark-circle-2-outline"></i>
                  {t('create.report.show.answer.option.options2.type')}
                </span>
              </>
            ) : (
              ''
            )}

            {rowData[dataKey] === 'ERROR' ? (
              <>
                <span>
                  {' '}
                  <i className="eva eva-alert-triangle-outline"></i>
                  {t('create.report.show.answer.option.options5.type')}
                </span>
              </>
            ) : (
              ''
            )}
          </div>
          <div className={rowData[dataKey] === 'ERROR' ? 'action-icons error' : 'action-icons'}>
            {rowData[dataKey] === 'ERROR' ? (
              <i
                className="eva eva-alert-triangle-outline red-color"
                data-tip={t('reports.generating.error')}
                data-for="tool-tip1"
              ></i>
            ) : (
              <>
                {/* <i
                  className="eva eva-download-outline disabled"
                  // data-tip={t('report.tooltip.download')}
                  // data-for="tool-tip"
                /> */}
                {/* <i
                  className="eva eva-share-outline disabled"
                  //data-tip={t('report.tooltip.share')}
                  //data-for="tool-tip"
                  //onClick={(event) => onShareClick(event,rowData)}
                ></i> */}
              </>
            )}
            <i
              className="eva eva-trash-2-outline"
              data-tip={t('report.tooltip.delete')}
              data-for="tool-tip1"
              onClick={event => deleteReport(event, rowData)}
            ></i>
          </div>
        </div>
      </Table.Cell>
    );
  };
  return (
    <div>
      {toaster ? (
        <div className="report-toaster">
          <span>
            <i className="eva eva-checkmark-outline"></i>
          </span>
          {t('reports.deleted')}
        </div>
      ) : (
        ''
      )}

      <AppTooltip id="tool-tip" place="left" className="c-table-info-icon--tooltip" />
      <Table
        data={getData()}
        sortColumn={sortColumn}
        sortType={sortType}
        headerHeight={50}
        autoHeight={true}
        onSortColumn={handleSortColumn}
        onRowClick={e => handleRowClick(e)}
      >
        <Table.Column width={getWidth(7)} align="left" sortable>
          <Table.HeaderCell>
            <i
              className="eva eva-repeat-outline"
              data-tip={isNickName ? t('report.tooltip.toggle2') : t('report.tooltip.toggle1')}
              data-for="tool-tip"
              onClick={event => toggleName(event)}
            ></i>
            {isNickName ? t('reportTable.text.reportName') : t('reportTable.text.reportId')}
          </Table.HeaderCell>
          <NameCell dataKey="reportName" isNickName={isNickName} />
        </Table.Column>

        <Table.Column width={getWidth(8)} resizable>
          <Table.HeaderCell>{t('reportTable.text.dateRange')} (DD-MM-YYYY)</Table.HeaderCell>
          <TableCell dataKey="dateRange" />
        </Table.Column>

        <Table.Column width={getWidth(8)} resizable sortable>
          <Table.HeaderCell>{t('reportTable.text.advertiser')}</Table.HeaderCell>
          <TableCell dataKey="advertiser" />
        </Table.Column>

        <Table.Column width={getWidth(8)} resizable sortable>
          <Table.HeaderCell>{t('reportTable.text.industry')}</Table.HeaderCell>
          <TableCell dataKey="industry"></TableCell>
        </Table.Column>

        <Table.Column width={getWidth()} resizable sortable>
          <Table.HeaderCell>{t('reportTable.text.country')}</Table.HeaderCell>
          <TableCell dataKey="country" />
        </Table.Column>

        <Table.Column width={getWidth()} resizable sortable>
          <Table.HeaderCell>{t('reportTable.text.kpi')}</Table.HeaderCell>
          <TableCell dataKey="kpi" />
        </Table.Column>

        <Table.Column width={getWidth(7)} resizable sortable>
          <Table.HeaderCell>{t('reportTable.text.created')} (DD-MM-YYYY)</Table.HeaderCell>
          <TableCell dataKey="createdModify" />
        </Table.Column>

        <Table.Column width={getWidth()}>
          <Table.HeaderCell>{t('reportTable.text.status')}</Table.HeaderCell>
          <StatusCell dataKey="status" />
        </Table.Column>
      </Table>
      <div className="pagination-div">
        <span>{t('reports.per.page')}</span>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          layout={['-', 'limit', '|', 'pager']}
          total={listData.length}
          limitOptions={[10, 15]}
          limit={limit}
          activePage={page}
          onChangePage={setPage}
          onChangeLimit={handleChangeLimit}
        />
      </div>
      <ModalWindow
        className="fqa-modal-share"
        isOpen={showShareModal}
        onRequestClose={handleOnCloseShareModal}
        heading={t('create.report.share.modal.heading')}
      >
        <p>{t('create.report.share.modal.instruction1')}</p>
        <p className="report-id">"{selectedReportShare?.reportId}"</p>
        <form onSubmit={handleSubmit}>
          <div className="share-form">
            <div className="c-business--account--dropdown">
              <label>{t('create.report.share.modal.instruction2')}</label>
              <Dropdown
                className="user-select"
                value={[selectedUser]}
                options={usersList}
                // onSelect={handleOnSelect}
                placeholder={t('create.report.share.modal.placeholder1')}
              />
            </div>
            <div className="comment">
              <label>{t('create.report.share.modal.instruction3')}</label>
              <textarea placeholder={t('create.report.share.modal.placeholder2')}></textarea>
            </div>
            <div className="footer-section">
              <Button
                type="button"
                className="fqa-model-pa--actions-confirm"
                label={t('create.report.share.modal.button')}
                //handleClick={handleCreateReport}
              />
            </div>
          </div>
        </form>
      </ModalWindow>
    </div>
  );
}

export default ReportTable;
